import { render, staticRenderFns } from "./CardTarjaEnqueteTaNaAreaSportv.vue?vue&type=template&id=39950918&scoped=true"
import script from "./CardTarjaEnqueteTaNaAreaSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTaNaAreaSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTaNaAreaSportv.vue?vue&type=style&index=0&id=39950918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39950918",
  null
  
)

export default component.exports